const initialState = {
    isFetchingUsersCount : false,
    userDeleted: false,
    selectedUser:[]
}

const usersReducer = (state =initialState , action) => {
    switch(action.type){
        case 'DELETE_USER_SUCCESS':
            return {...state, userDeleted: true};

        case 'SELECTED_USER':
            return {
                ...state,
                selectedUser : action.data 
            }
            
        default :
        return state;
    }
}

export default usersReducer;